
import { Component, Vue } from 'vue-property-decorator';
import { getReservationReviewList, deleteReservationReviewReply } from '@/api/reservationReview';
import Pagination from '@/components/Pagination/index.vue';
import ReplyForm from './components/ReplyForm.vue';

@Component({
  components: {
    Pagination,
    ReplyForm,
  },
})
export default class extends Vue {
  mounted() {
    this.getList();
  }

  private listQuery = {
    page: 1,
    size: 10,
    searchType: 'name',
    searchValue: '',
  };

  private reviewList = [];

  private totalElements = 0;

  private loading = true;

  private replyFormVisible = false;

  private selectedReview: any = null;

  private getList() {
    this.loading = true;
    getReservationReviewList(this.listQuery).then((res) => {
      this.loading = false;
      this.reviewList = res.data.content;
      this.totalElements = res.data.totalElements;
    });
  }

  private handleSearch() {
    this.listQuery.page = 1;
    this.getList();
  }

  private getSrcList(images: any) {
    if (images && images.length > 0) {
      return images.map((x: any) => `/api/attached-file/${x.fileUid}`);
    }
    return [];
  }

  private handleSuccessReply() {
    this.getList();
    this.handleVisibleForm(null);
  }

  private handleVisibleForm(review: any) {
    this.selectedReview = review;
    this.replyFormVisible = !this.replyFormVisible;
  }

  private handleDeleteReply(review: any) {
    this.$confirm('정말 리뷰 답변을 삭제하시겠습니까?', '리뷰 답변 삭제', {
      confirmButtonText: '예',
      cancelButtonText: '아니오',
      type: 'error',
    }).then(() => {
      deleteReservationReviewReply(review.idx).then(() => {
        this.getList();
        this.$message.success('리뷰 답변이 삭제되었습니다.');
      });
    });
  }
}
